import axios from '@/utils/api'

const actions = {
  async salvar ({ commit }, despacho) {
    return axios({
      url: `despacho/salvar`,
      method: 'PUT',
      data: despacho
    })
  },
  async finalizar ({ commit }, { acao, despacho }) {
    return axios({
      url: `despacho/finalizar`,
      method: 'POST',
      data: {
        acao,
        despacho
      }
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/despacho.js